// @ts-nocheck
import React from 'react'
import { Link as RouterLink, LinkProps } from 'react-router-dom'

export interface ILink extends Partial<LinkProps> {
  /** Path to navigate to */
  to?: string
  /** Render <a> tag with "href" prop */
  href?: string
  /** Inner content of the Link */
  children?: React.ReactNode
}

const Link = (props: ILink): React.ReactElement => {
  const { to, href, children, ...rest } = props

  if (to) {
    return (
      <RouterLink to={to} {...rest}>
        {children}
      </RouterLink>
    )
  }
  if (href) {
    return (
      <a href={href} {...rest}>
        {children}
      </a>
    )
  }
  return children as React.ReactElement
}

export default Link
